import { TextFormatEnum as e } from "../text-format-enum.mjs";
import { Bold01Icon as t, Italic01Icon as n, Strikethrough01Icon as r, Underline01Icon as i } from "@systemeio/icons";
//#region src/extensions/text-format-extension/utils/text-format.ts
var a = ({ formatType: t, editor: n }) => {
	if (n) switch (t) {
		case e.Bold:
			n.chain().focus().toggleBold().run();
			break;
		case e.Italic:
			n.chain().focus().toggleItalic().run();
			break;
		case e.Underline:
			n.chain().focus().toggleUnderline().run();
			break;
		case e.Strike: n.chain().focus().toggleStrike().run();
	}
}, o = ({ formatType: a }) => {
	switch (a) {
		case e.Bold: return t;
		case e.Italic: return n;
		case e.Underline: return i;
		case e.Strike: return r;
	}
};
//#endregion
export { o as getTextFormatIcon, a as setTextFormat };
